import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m20.495 14.256.53.53.002-.002zm-6.23 6.23-.53-.53h-.001zm-2.46 0 .531-.53zM4 12.689h-.75V13l.22.22zM4 4v-.75a.75.75 0 0 0-.75.75zm8.69 0 .53-.53-.22-.22h-.31zm7.805 7.805.532-.528-.002-.002zm-.53 1.92-6.23 6.23 1.06 1.061 6.23-6.23zm-6.231 6.23a.99.99 0 0 1-.7.29v1.5c.661 0 1.294-.262 1.761-.729zm-.7.29a1 1 0 0 1-.698-.29l-1.061 1.061c.466.467 1.1.73 1.76.73zm-.699-.29L4.53 12.16l-1.06 1.06 7.805 7.798zM4.75 12.69V4h-1.5v8.69zM4 4.75h8.69v-1.5H4zm8.159-.22 7.805 7.806 1.061-1.06L13.22 3.47zm7.804 7.804a.99.99 0 0 1 0 1.393l1.063 1.057a2.49 2.49 0 0 0 0-3.507z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M11.25 9.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }